/**
 * プラットフォーム検出ユーティリティ
 * iOS/AndroidネイティブアプリとWebを判別
 */

import { Capacitor } from '@capacitor/core'

/**
 * ネイティブアプリ（iOS/Android）かどうかを判定
 */
export const isNativeApp = (): boolean => {
  return Capacitor.isNativePlatform()
}

/**
 * Webブラウザかどうかを判定
 */
export const isWebApp = (): boolean => {
  return !Capacitor.isNativePlatform()
}

/**
 * 現在のプラットフォームを取得
 * @returns 'ios' | 'android' | 'web'
 */
export const getPlatform = (): 'ios' | 'android' | 'web' => {
  const platform = Capacitor.getPlatform()
  if (platform === 'ios') return 'ios'
  if (platform === 'android') return 'android'
  return 'web'
}

/**
 * iOSネイティブアプリかどうかを判定
 */
export const isIOS = (): boolean => {
  return Capacitor.getPlatform() === 'ios'
}

/**
 * Androidネイティブアプリかどうかを判定
 */
export const isAndroid = (): boolean => {
  return Capacitor.getPlatform() === 'android'
}

/**
 * ネイティブアプリでは課金関連のUI（価格表示、課金ボタン等）を
 * 表示してはいけないため、このフラグで制御
 * Apple/Googleのガイドラインにより、外部決済への誘導は禁止
 */
export const shouldShowPricingUI = (): boolean => {
  return isWebApp()
}
